{
  "replaceMessage": "删除要替换的文件"
}
